import {FC, useContext, useMemo} from 'external/react'
import {styled} from 'external/material'
import PlanificationAccordion from 'components/planning/plan-rd/components/PlanificationAcordion'
import { TeacherContext } from 'teacher/context'

import DailyTimeInfo from './DailyTimeInfo'
import DailyIntent from './DailyIntent'
import { DayMoments } from './DayMoments'

const StyledDailyPlanning = styled(PlanificationAccordion)(dailyPlanninStyles as any)

type DailyPlanningProps = {
  title: string;
  id: number;
  refu: React.RefObject<HTMLDivElement> | null;
}

export const DailyPlanning: FC<DailyPlanningProps> = props => {

  const {title, id, refu} = props

  const {updateState, newPlan} = useContext(TeacherContext) as any
  
  function deleteDailyPlan() {
    updateState({newPlan: {content: {dailyPlanning: {$splice: [[id, 1]]}}}})
  }
  
  const dailyPlan = useMemo(() => newPlan.content?.dailyPlanning[id] , [newPlan, id])

  return (
    <StyledDailyPlanning title={title} deleteButton={true} handleDelete={deleteDailyPlan}>
      <div ref={refu} className='daily-planning'>
        {dailyPlan && (<>
          <div className='time-info'>
            <div className='filler'/>
            <DailyTimeInfo id={id} dailyPlan={dailyPlan} /> 
          </div>
          <DailyIntent id={id} />
          <DayMoments id={id} />
        </>)}
      </div>
    </StyledDailyPlanning>
  );
}

function dailyPlanninStyles() {
  return {
    '& .daily-planning': {
      display: 'flex',
      width: '100%',
      padding: '16px',
      boxSizing: 'border-box',
      flexDirection: 'column',
      gap: '16px',
      '& .filler': {
        flexGrow: 1
      },
      '& .time-info': {
         display: 'flex',
         justifyContent: 'flex-start',
         width: '100%',
         height: '60px',
         alignItems: 'center',
         gap: '20px' 
      }
    }
  }
}